<template>
  <v-tabs
    background-color="secondary"
    class="rounded-0"
    dark
    grow
    show-arrows
    slider-color="light-green"
  >
    <v-tab
      v-if="posUserHasRoutePermission('/orders/today') && posUserHasComponentPermission('Orders', 'ACCESS') && userCanViewDailyOrders"
      active-class="secondary darken-1 v-tabs__item--active"
      ripple
      to="/orders/today"
    >
      <v-badge
        v-model="todayOrdersVisible"
        color="red"
        right
      >
        <template #badge>
          <span>
            {{ todayOrdersCount }}
          </span>
        </template>
        <span>{{ $t('Order.OrdersToolbar.Today').toLocaleUpperCase($i18n.locale) }}</span>
      </v-badge>
    </v-tab>

    <v-tab
      v-if="posUserHasRoutePermission('/orders/scheduled') && posUserHasComponentPermission('Orders', 'ACCESS') && userCanViewScheduledOrders"
      active-class="secondary darken-1 v-tabs__item--active"
      ripple
      to="/orders/scheduled"
    >
      <v-badge
        v-model="scheduledOrdersVisible"
        color="red"
        right
      >
        <template #badge>
          <span>
            {{ scheduledOrdersCount }}
          </span>
        </template>
        <span>{{ $t('Order.OrdersToolbar.Scheduled').toLocaleUpperCase($i18n.locale) }}</span>
      </v-badge>
    </v-tab>

    <v-tab
      v-if="posUserHasRoutePermission('/orders/saved') && posUserHasComponentPermission('Orders', 'ACCESS') && posUserHasComponentPermission('Pos', 'ACCESS') && userCanViewSavedOrders"
      active-class="secondary darken-1 v-tabs__item--active"
      ripple
      to="/orders/saved"
    >
      <span>{{ $t('Order.OrdersToolbar.Saved').toLocaleUpperCase($i18n.locale) }}</span>
    </v-tab>

    <v-tab
      v-if="posUserHasRoutePermission('/orders/all') && posUserHasComponentPermission('Orders', 'ACCESS') && userCanViewAllOrders"
      active-class="secondary darken-1 v-tabs__item--active"
      ripple
      to="/orders/all"
    >
      <span>{{ $t('Order.OrdersToolbar.All').toLocaleUpperCase($i18n.locale) }}</span>
    </v-tab>
  </v-tabs>
</template>

<script>
import AppData from '../../mixins/appdata'
import Auth from '../../mixins/auth'

export default {
  mixins: [AppData, Auth],
  data() {
    return {}
  },
  computed: {
    todayOrdersCount() {
      return window.Vue.ordersCounts.daily_count
    },
    todayOrdersVisible: {
      get() {
        return this.todayOrdersCount > 0
      },
      set() {

      }
    },
    savedOrdersCount() {
      return window.Vue.ordersCounts.saved_count
    },
    savedOrdersVisible: {
      get() {
        return this.savedOrdersCount > 0
      },
      set() {

      }
    },
    scheduledOrdersCount() {
      return window.Vue.ordersCounts.future_count
    },
    scheduledOrdersVisible: {
      get() {
        return this.scheduledOrdersCount > 0
      },
      set() {

      }
    }
  }
}
</script>
